module.exports = __webpack_public_path__ + "static/media/empty.7411d6da.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/empty.png
// module id = 445
// module chunks = 0